var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecrease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Decrease",
    transform: "translate(1847 3586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(-1847 -3586)",
    fill: "#2a374e",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Latest_to_Earliest",
    "data-name": "Latest to Earliest",
    transform: "translate(-1828.999 -3570.314) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(3.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(9 13.686) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M7.976,8.162,5.224,10.914,5,0H3.546l.229,10.914L1.024,8.162,0,9.186l4.5,4.5L9,9.186Z",
    fill: "#d72525",
    stroke: "#d72525",
    strokeWidth: 0.3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.50c723dad38e373f53120149ebeb5307.svg";
export { ForwardRef as ReactComponent };